import React from "react";
import {
  Box,
  Typography,
  Container,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import GavelIcon from "@mui/icons-material/Gavel";

const Disclaimer = () => {
  return (
    <Box sx={{ py: 8, minHeight: "100vh" }}>
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(0,0,0,0.05)",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, mb: 2, color: "primary.main" }}
          >
            Disclaimer
          </Typography>

          <Divider sx={{ mb: 4 }} />

          {/* Intermediary Role Disclaimer */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Intermediary Role of JEMINS
          </Typography>

          <Typography paragraph>
            JEMINS (operated by Jemins RealtyMart / Jemins Builders) is an online platform that acts solely as an intermediary
            to facilitate the display and exchange of information between
            property owners, developers, agents, sellers, and prospective
            buyers, tenants, or users. JEMINS does not own, control, endorse, or
            guarantee any property listings, projects, advertisements, or
            transactions displayed on the platform.
          </Typography>

          <Typography paragraph>
            JEMINS is not a party to any agreement, transaction, or communication
            between the seller, developer, broker, or agent and the buyer,
            tenant, or user. All property-related negotiations, agreements,
            payments, verifications, and due diligence are the sole
            responsibility of the respective parties involved.
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 3, mb: 1, fontWeight: 600 }}>
            JEMINS shall not be responsible or liable for:
          </Typography>

          <List dense>
            {[
              "The accuracy, completeness, legality, or authenticity of property listings or information",
              "Any loss, damage, fraud, delay, dispute, or disagreement arising between users and sellers",
              "Any financial, legal, or contractual obligations entered into by users based on information available on the platform",
            ].map((item, index) => (
              <ListItem key={index} sx={{ px: 0 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <WarningAmberIcon color="warning" fontSize="small" />
                </ListItemIcon>
                <Typography variant="body2">{item}</Typography>
              </ListItem>
            ))}
          </List>

          <Typography paragraph sx={{ mt: 2 }}>
            Any disputes, claims, or disagreements between the buyer/user and
            the seller, developer, or agent shall be resolved directly between
            the concerned parties, without involving JEMINS in any manner.
          </Typography>

          <Typography paragraph>
            Users are strongly advised to independently verify all property
            details, documents, approvals, pricing, and credentials before
            proceeding with any transaction.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* General Information */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            General Information
          </Typography>
          <Typography paragraph>
            The information provided on this real estate platform is for general
            informational purposes only. While we strive to keep property
            listings, pricing, and related details accurate and up to date, we
            make no guarantees of completeness, accuracy, or reliability.
          </Typography>

          {/* Property Listings */}
          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            Property Listings & Pricing
          </Typography>
          <List dense>
            {[
              "Property images are for illustrative purposes only",
              "Prices are subject to change without prior notice",
              "Availability may change based on market conditions",
              "Specifications and amenities may vary from actual offerings",
            ].map((item, index) => (
              <ListItem key={index} sx={{ px: 0 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <InfoIcon color="primary" fontSize="small" />
                </ListItemIcon>
                <Typography variant="body2">{item}</Typography>
              </ListItem>
            ))}
          </List>

          {/* Acceptance */}
          <Typography variant="h6" sx={{ mt: 4, mb: 2, fontWeight: 600 }}>
            Acceptance of Disclaimer
          </Typography>
          <Typography paragraph>
            By using this platform, you acknowledge that you have read,
            understood, and agreed to this Disclaimer. If you do not agree with
            any part of this Disclaimer, please discontinue use of the platform.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Disclaimer;